var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"priceTp"}},[_c(_vm.listHeaderTemplateBoard,{tag:"component"}),_vm._v(" "),_c('div',{staticClass:"vux-1px-b wl_hr_side0"}),_vm._v(" "),_c('list-arrange',{attrs:{"data":_vm.listArrange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1846d52a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-temporary/priceTp.vue
// module id = null
// module chunks = 